window.addEventListener("load", () => {
  const ReactRailsUJS = require("react_ujs");
  const context = require.context('Pods', true, /\/Blog\/(?!.*(?:test|story).*$).*$/)

  ReactRailsUJS.useContext(context);
  ReactRailsUJS.mountComponents("#blog-elements");
});
